export default ([r, g, b], { threshold = 127 } = {}) =>
  Math.round(((Math.floor(r) * 299) + (Math.floor(g) * 587) + (Math.floor(b) * 114)) / 1000) <= threshold
    ? 'white'
    : 'black'



// WEBPACK FOOTER //
// ./src/utils/color-contrast.js